
import React, { useEffect, useState } from "react";
import { useCreateSupplierMutation, useDeleteSupplierMutation, useGetSuppliersQuery, useUpdateSupplierMutation } from "../../store/api/supplierApi";
import {  useGetProductsQuery} from "../../store/api/productsApi";
import { FaRegEdit } from "react-icons/fa";
import Swal from "sweetalert2";
import { BsFillCameraFill, BsTrashFill } from "react-icons/bs";
import DataTable from 'react-data-table-component'
import { IoSearch } from "react-icons/io5";
import { useCreateConsumerMutation, useDeleteConsumerMutation, useGetConsumerQuery, useUpdateConsumerMutation } from "../../store/api/consumerApi";





const initialConsumer = {
  Id: 0,
  name: '',
  phone: '',
}


export default function Suppliers() {
  
  const [isUpdate, setIsUpdate] = useState(false);
  const [consumer, setConsumer] = useState(initialConsumer)
  const [CreateConsumer] = useCreateConsumerMutation()
  const [updateConsumer] = useUpdateConsumerMutation()
  const [deleteCustomer] = useDeleteConsumerMutation()

  const [consumersList, setConsumersList] = useState([]);
  const { data } = useGetConsumerQuery();

  // Update suppliers state when data changes

  useEffect(() => {
    if (data) {
      setConsumersList(data);
    }
  }, [data]);

  // products  . . .

  const [file, setFile] = useState(null);
  // select file for the new product
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };


  // create new supplier method
  const handlecreateConsumer = async (event) => {
    event.preventDefault()

    const Data = {
      name: consumer.name,
      phone: consumer.phone,
    }

    await CreateConsumer(Data).then((done) => {
        console.log('done', done.data.status)
        if (done.data.status === 200) {
          Swal.fire({
            title: 'Success!',
            text: done.data.message,
            icon: 'success',
            confirmButtonText: 'Done'
          })
        } else {
          Swal.fire({
            title: 'Error!',
            text: done.data.message,
            icon: 'error',
            confirmButtonText: 'close'
          })
        }
      })


  }


  // update exist consumer
  const handleUpdatesConsumer = async (e) => {
    e.preventDefault()

    const consumerData = {
      Id: consumer.Id,
      name: consumer.name,
      phone: consumer.phone,
    }


    await updateConsumer(consumerData).then((done) => {
      if (done?.data.status === 200) {
        Swal.fire({
          title: 'Success!',
          text: done.data.message,
          icon: 'success',
          confirmButtonText: 'Done'
        })
      } else {
        Swal.fire({
          title: 'Error!',
          text: done.data.message,
          icon: 'error',
          confirmButtonText: 'Close'
        })
      }
    });

    ResetFormChanges();
  }



  // Delete supplier

  const handleDelete = async (value) => {
    const { id } = value
    Swal.fire({
      title: 'Are you sure?',
      text: 'you want to delete this supplier !!!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#022B3A',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        deleteCustomer(id).then((done) => {
          if (done?.data.status === 200) {
            Swal.fire({
              title: 'Success!',
              text: done.data.message,
              icon: 'success',
              confirmButtonText: 'Done'
            })
          } else {
            Swal.fire({
              title: 'Error!',
              text: done.data.message,
              icon: 'error',
              confirmButtonText: 'Close'
            })
          }
        })
      }
    })
  }


  const resetFormData = () => {
    setConsumer({
      ...initialConsumer,
    });
    setFile(null);
  };


  // reading suppliers list







  // prepare data supplier to be updated
  const handleUpdate = (updateData) => {
      
      if (!isUpdate) {
        setIsUpdate(!isUpdate);
      }
   
      setConsumer({
        Id: updateData.id,
        name: updateData.name,
        phone: updateData.phone,
      })
    
  }



   // search products
   const searchConsumers = (searchText) => {
    if (!searchText) {
      return consumersList
    }

    const filteredconsumersList = consumersList.filter((consumer) => {
      const nameMatch = consumer.name.toLowerCase().includes(searchText.toLowerCase())
      const phoneMatch = consumer.phone.toString() === searchText
      return nameMatch || phoneMatch
    })

    return filteredconsumersList
  }


  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(3)
  const [formData, setFormData] = useState([])

  // changes pages
  const handlePageChange = (page) => {
    setPage(page)
  }

  // change perpage
  const handlePerPageChange = (perPage) => {
    setPerPage(perPage)
  }

  const ResetFormChanges = () => {
    setIsUpdate(!isUpdate);
    setConsumer(initialConsumer);
    setFile(null)
  }

  // search hanlder
  const handleSearch = (e) => {
    setFormData(searchConsumers(e.target.value))
  }







  // Consumers Table columns
  const _columns = [
    { name: 'Id', selector: (row) => row.id, sortable: true, center: true },
   
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
      center: true
    },
    {
      name: 'Phone',
      selector: (row) => row.phone,
      sortable: true,
      center: true
    },
    {
      name: 'Create At',
      selector: (row) => row.created,
      sortable: true,
      center: true
    },
    {
      name: 'Updated At',
      selector: (row) => row.updated,
      sortable: true,
      center: true
    },

    {
      name: 'Actions',
      cell: (row) => (
        <>
          <button
            style={{ background: '#1a2131' }}
            className="btn btn-success me-3 border-0  text-white"
            onClick={() => handleUpdate(row)}
          >
            <FaRegEdit />
          </button>
          <button
            style={{ background: '#A0374F' }}
            className="btn btn-danger me-3 text-white border-0"
            onClick={() => handleDelete(row)}
          >
            <BsTrashFill />
          </button>
        </>
      ),
      center: true
    }
  ]


  const paginatedData = formData.length
  ? formData.slice((page - 1) * perPage, page * perPage)
  : consumersList.slice((page - 1) * perPage, page * perPage)



  const canSave = [consumer.name, consumer.phone].every(Boolean)
  const canUpdate = [consumer.name, consumer.phone].every(Boolean)






  return (
    <div>
      <div className="block-content-full">
        <div class="block-content">

          <div className="row">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xl-4 col-12">
              <form>
                <div className="row">
                <div className="col-sm-12 hover">
                      <div className="mb-3">
                        <div className="row">
                          <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                            Consumer Name
                          </label>
                        </div>
                        <input
                        style={{ height: '45px' }}
                        autoComplete='off'
                          type="text"
                          className="form-control"
                          id="exampleFormControlInput1"
                          placeholder="consumer name"
                          value={consumer.name}
                          onChange={(e) => setConsumer({ ...consumer, name: e.target.value })}
                        />
                      </div>
                    </div>

                    <div className="col-sm-12 hover">
                      <div className="mb-3">
                        <div className="row">
                          <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                            Consumer Phone
                          </label>
                        </div>
                        <input
                        style={{ height: '45px' }}
                        autoComplete='off'
                          type="text"
                          className="form-control"
                          id="exampleFormControlInput1"
                          placeholder="consumer phone"
                          value={consumer.phone}
                          onChange={(e) => setConsumer({ ...consumer, phone: e.target.value })}
                        />
                      </div>
                    </div>
                </div>

                <div class="mt-3 pb-3">

                  <button
                    type="submit"
                    class={isUpdate ? "btn btn-success p-2" : "btn btn-primary p-2"}
                    data-dismiss="modal"
                    onClick={isUpdate ? handleUpdatesConsumer : handlecreateConsumer}
                    disabled={isUpdate ? !canUpdate : !canSave}
                  >
                    {isUpdate ? "Update Changes" : "Save changes"}
                  </button>
                  {
                    isUpdate ?  <button
                      type="submit"
                      class={"btn btn-secondary p-2 mx-3"}
                      data-dismiss="modal"
                      onClick={ResetFormChanges}
                      
                    >
                      Reset
                    </button>: (<></>)
                  }
                </div>
              </form>
            </div>
            <div className="col-md-12 col-lg-12 col-sm-12 col-xl-8 col-12 bg-light vh-100">
              <div className="block-content block-content-full">
                <h2 className="content-heading">Consumers List</h2>
                <div className="d-flex mb-3">
              <div className="input-group">
                <input
                  className="form-control"
                  placeholder="Search..."
                  type="text"
                  style={{ height: '40px' }}
                  //value={searchText}
                  onChange={handleSearch}
                />
                <div className="input-group-append">
                  <span className="input-group-text">
                    <IoSearch />
                  </span>
                </div>
              </div>
          
            </div>
              </div>
              <DataTable
                pointerOnHover
                className="rounded-3"
                columns={_columns}
                data={paginatedData}
                striped
                highlightOnHover
                pagination
                paginationServer
                paginationTotalRows={consumersList.length}
                paginationPerPage={perPage}
                paginationRowsPerPageOptions={[1, 3, 5, 50]}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerPageChange}
              />

          
            </div>
          </div>


        </div>
      </div>
    </div>
  );
}
